import { render } from "./UserEditSessions.vue?vue&type=template&id=6ae5a774&scoped=true"
import script from "./UserEditSessions.vue?vue&type=script&lang=js"
export * from "./UserEditSessions.vue?vue&type=script&lang=js"

import "./UserEditSessions.vue?vue&type=style&index=0&id=6ae5a774&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae5a774"]])

export default __exports__